import { PaintRowDraft } from '../types'
import { getReference } from './get-reference'

function toKey(items: { colorantDocumentId?: string | null; amount?: number | null }[]) {
    return items
        .filter(item => item.colorantDocumentId)
        .map(item => `${item.colorantDocumentId}:${item.amount ?? ''}`)
        .sort()
        .join('|')
}

/** Состав отличается от эталона (или эталона нет, а состав собран) — при завершении печати будет новая версия. */
export function isCompositionChanged(draft: PaintRowDraft) {
    const reference = getReference(draft)
    const referenceItems = (reference?.colorants ?? []).map(item => ({
        colorantDocumentId: item.colorant?.documentId,
        amount: item.amount,
    }))
    return toKey(draft.colorants) !== toKey(referenceItems)
}
